import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap" // Adjust this based on your UI library

function MobileTableBody({ item, rowEdit, onClickDelete, AccessAdmin }) {
  const formatDate = date => moment(date).format("DD-MM-YY")

  const renderTableRow = (label, value) => (
    <tr key={label}>
      <th scope="row" className="text-uppercase">
        {label}
      </th>
      <td>{value}</td>
    </tr>
  )

  return (
    <>
      {renderTableRow("Start Date", formatDate(item.startDate))}
      {renderTableRow("End Date", formatDate(item.endDate))}
      {renderTableRow("EmpName", item.userName)}
      {renderTableRow("Project", item.subcategoryName)}
      {renderTableRow("Maximum Hours", item.maximumHours)}
      {renderTableRow("Comments", item.comments)}
      {AccessAdmin == "Admin" && renderTableRow(
        "Action",
        <div
          role="button"
          style={{
            cursor: "pointer",
            // textAlign: !isMobile ? "center" : "start",
          }}
        >
          <UncontrolledDropdown>
            <DropdownToggle href="#" className="card-drop" tag="i">
              <i className="mdi mdi-dots-vertical font-size-18" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem href="#" onClick={() => rowEdit(item)}>
                Edit
              </DropdownItem>
              <DropdownItem href="#" onClick={() => onClickDelete(item)}>
                Delete
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      )}
    </>
  )
}

MobileTableBody.propTypes = {
  item: PropTypes.object.isRequired,
  rowEdit: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
}

export default MobileTableBody
